export const useGroupsPages = async () => {
	const { locale } = useI18n();
	const groupsPages = useState('groupsPages', () => {});

	const setGroupsPages = (data) => {
		groupsPages.value = data;
	};

	const fetchGroupsPages = async () => {
		const { data: groupsPages } = await useWebsiteFetch('pages', {
			api: 'group',
			// ID 7 = News, ID 30 = Vacancies
			query: { language: locale.value, pageIds: '7,30' },
			key: `${locale.value}/groupsPages`,
		});

		setGroupsPages(groupsPages);
	};

	return {
		groupsPages,
		fetchGroupsPages,
	};
};
